// extracted by mini-css-extract-plugin
export default {"figmaContainer":"DynamicProjectComponent_figmaContainer__Fvflk"};